export const ordersDicionary: Record<string, string> = {
  'This order is closed.': 'Este pedido está fechado',
  'Error while creating order.': 'Houve um erro ao gerar o pedido',
  'Error while closing order.': 'Houve um erro ao cancelar o pedido',
  'Authorization has been denied for this request.':
    'A autorização foi negada para esta solicitação',
};
